import React, { useState, useEffect } from 'react';
import { summitMalattieRareEvent } from '../data/summitMalattieRare';

// News data. Le voci possono avere un contenuto testuale semplice (`content`)
// oppure un contenuto ricco in HTML (`htmlContent`) con eventuali documenti
// allegati (`documents`) e una locandina (`poster`).
const newsData = [
    {
        id: 2,
        title: summitMalattieRareEvent.title,
        author: summitMalattieRareEvent.organizers,
        date: summitMalattieRareEvent.date,
        color: "bg-blue-700",
        poster: summitMalattieRareEvent.poster,
        intro: summitMalattieRareEvent.intro,
        htmlContent: summitMalattieRareEvent.reportHtml,
        documents: summitMalattieRareEvent.documents
    },
    {
        id: 1,
        title: "CHE COSA È LA PICNOCITOSI? E PERCHÉ DESIDERO PARLARNE?",
        author: "Dott.ssa Anna Maria Testi",
        content: "Anche in questo caso siamo di fronte ad una malattia rara e, non solo per incidenza, ma anche perché non sempre riconosciuta e diagnosticata.\n \n  Questa malattia insorge nel neonato, intorno alla seconda settimana di vita, ed è caratterizzata dalla presenza di globuli rossi anomali detti picnociti. La patologia non è trasmessa dai genitori, ma per cause non ancora ben conosciute, i globuli rossi del neonato perdono la loro forma originale e diventano contratti, più densi e presentano una superficie spinosa. Purtroppo muoiono più rapidamente dei globuli rossi normali, causando aumento della bilirubina e anemia, a volte grave. Pensate che la malattia è stata descritta per la prima volta dal prof. Tuffy nel 1959 e, da allora non sono stati fatti grandi progressi per consentirci di capire come evitare il verificarsi di questo evento. Abbiamo però imparato a gestirla con l’impiego della fototerapia, exsanguinotrasfusioni per mantenere i livelli di bilirubina entro limiti di sicurezza e trasfusioni di globuli rossi concentrati per correggere l’anemia. In rari casi, anche dopo l’intenso trattamento, i picnociti rimangono; sono stati allora utilizzati alcuni farmaci, quali l’eritropoietina, per stimolare la produzione di globuli rossi sani. \n \n Come si fa la diagnosi di questa malattia ? E’ molto semplice, ma bisogna pensarci. Si striscia su un vetrino una goccia di sangue del neonato, si effettua la normale colorazione e, al microscopio ottico è possibile osservare i picnociti. Al momento, non sono necessari altri tests, come quello genetico che comportano ulteriore prelievo di sangue al piccolo paziente. \n \nDesidero quindi rivolgermi ai neonatologi, pediatri ematologi per ricordare che questa malattia esiste e bisogna pensarci tutte le volte che si osserva anemia e aumento della bilirubina nel neonato, per poter iniziare il prima possibile il trattamento.",
        color: "bg-accent",
        images: []
    }
];

const News = () => {
    const [showScrollTop, setShowScrollTop] = useState(false);

    // Scroll to top button visibility
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Function to scroll to top
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Hero Section */}
            <div className="bg-gradient-to-r from-primary to-primary/80">
                <div className="container mx-auto px-4 py-16 md:py-24">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">News</h1>
                        <p className="text-xl text-white md:w-3/4 mx-auto">
                            Le ultime notizie e aggiornamenti dall'Associazione Robin Hood Roma ODV.
                        </p>
                    </div>
                </div>
            </div>

            {/* News List Section */}
            <div className="container mx-auto px-4 py-8">
                <div className="grid grid-cols-1 gap-8">
                    {newsData.length > 0 ? (
                        newsData.map((item) => (
                            <div
                                key={item.id}
                                className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-all duration-300"
                            >
                                <div className={`${item.color} text-white p-4`}>
                                    <h2 className="text-2xl font-bold">{item.title}</h2>
                                    <div className="text-sm mt-2 opacity-90 flex flex-col sm:flex-row sm:items-center sm:gap-4">
                                        <span className="flex items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" focusable="false">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                            </svg>
                                            {item.author}
                                        </span>
                                        {item.date && (
                                            <span className="flex items-center mt-1 sm:mt-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" focusable="false">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                                {item.date}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className="p-6">
                                    {(item.poster || item.intro) && (
                                        <div className="flex flex-col md:flex-row gap-6 mb-6">
                                            {item.poster && (
                                                <img
                                                    src={item.poster}
                                                    alt={`Locandina ${item.title}`}
                                                    className="w-full max-w-[14rem] md:max-w-none md:w-56 h-auto object-contain rounded-md shadow-sm mx-auto md:mx-0 flex-shrink-0"
                                                />
                                            )}
                                            {item.intro && (
                                                <p className="text-gray-700 self-center">{item.intro}</p>
                                            )}
                                        </div>
                                    )}
                                    {item.htmlContent ? (
                                        <div
                                            className="max-w-none text-gray-700"
                                            dangerouslySetInnerHTML={{ __html: item.htmlContent }}
                                        />
                                    ) : (
                                        <div className="prose max-w-none text-gray-700 whitespace-pre-line">
                                            {item.content}
                                        </div>
                                    )}
                                    {item.documents && item.documents.length > 0 && (
                                        <div className="mt-6 pt-5 border-t border-gray-200">
                                            <h4 className="font-semibold text-gray-800 mb-3">Documenti dell'evento</h4>
                                            <div className="flex flex-col sm:flex-row flex-wrap gap-3">
                                                {item.documents.map((doc) => (
                                                    <a
                                                        key={doc.label}
                                                        href={doc.file}
                                                        download={doc.downloadName}
                                                        className="inline-flex items-center px-4 py-2 bg-accent text-white text-sm font-medium rounded-md hover:bg-accent/90 transition-colors duration-200"
                                                        aria-label={`Scarica ${doc.label}`}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true" focusable="false">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                                                        </svg>
                                                        Scarica {doc.label}
                                                    </a>
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-600 italic text-center">Nessuna news presente al momento.</p>
                    )}
                </div>
            </div>

            {/* Scroll to Top Button */}
            {showScrollTop && (
                <button
                    onClick={scrollToTop}
                    className="fixed bottom-8 right-8 bg-green-600 text-white p-3 rounded-full shadow-lg hover:bg-green-700 transition-colors z-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    aria-label="Torna su"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                    </svg>
                </button>
            )}
        </div>
    );
};

export default News;
